import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { slideDownUp } from '../global-app-animations';

@Component({
  selector: 'app-custom-expansion-panel',
  templateUrl: './custom-expansion-panel.component.html',
  styleUrl: './custom-expansion-panel.component.scss',
  animations: [
    slideDownUp,
  ]
})
export class CustomExpansionPanelComponent implements OnInit, OnDestroy{

  @Input() isOpen: boolean = false; // Panel state (open/closed)
  

  constructor() {

  }

  ngOnInit(): void {
    
  }

  ngOnDestroy(): void {
    
  }

  togglePanel() {
    this.isOpen = !this.isOpen;
  }

}
